import http from "./http";

function get_location_wise_list(data) {
  return http.post(`geofenc_typeSetupList`, data);
}

function add_geofencing_data(data) {
  return http.post(`Save_geoFence_setup`, data);
}

function delete_geofencing_data(data) {
  return http.post(`deletegeofenc_type`, data);
}

function update_geofencing_data(data) {
  return http.post(`updategeofenc_type`, data);
}

const GeofencingSetupService = {
  get_location_wise_list,
  add_geofencing_data,
  delete_geofencing_data,
  update_geofencing_data,
};

export default GeofencingSetupService;
// ====================================
